import type { SVGProps } from 'react';

const SvgShareByMe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m20.71 15.29-2-2a.996.996 0 1 0-1.41 1.41l.29.29H17c-2.76 0-5 2.24-5 5 0 .55.45 1 1 1s1-.45 1-1c0-1.65 1.35-3 3-3h.59l-.29.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2-2a.996.996 0 0 0 0-1.41zM12 14c3.03 0 5.5-2.47 5.5-5.5S15.03 3 12 3a5.51 5.51 0 0 0-5.5 5.5c0 1.35.49 2.58 1.3 3.54A8.96 8.96 0 0 0 3 20c0 .55.45 1 1 1s1-.45 1-1c0-2.97 1.84-5.55 4.6-6.56.73.35 1.54.56 2.4.56m0-9c1.93 0 3.5 1.57 3.5 3.5S13.93 12 12 12s-3.5-1.57-3.5-3.5S10.07 5 12 5"
    />
  </svg>
);
export default SvgShareByMe;
